import * as update from "immutability-helper";
import * as moment from "moment";
import * as DTOS from "../FeralScan.dtos";
import { GET_PLOTS_REQUEST, GET_PLOTS_SUCCESS, GET_PLOT_EVENTS_REQUEST, GET_PLOT_EVENTS_SUCCESS, GET_PLOT_SEASON_SUMMARY_DATA_SUCCESS, GET_PLOT_SUMMARY_DATA_SUCCESS, GET_SINGLE_PLOT_REQUEST, GET_SINGLE_PLOT_SUCCESS, GET_SUMMARY_DATA_SUCCESS, GET_USER_PLOTS_REQUEST, GET_USER_PLOTS_SUCCESS, IGetPlotEventsSuccessAction, IGetPlotsSuccessAction, IGetSinglePlotSuccessAction, IGetSummaryDataSuccessAction, IGetUserPlotsSuccessAction, ISearchSuccessAction, SEARCH_REQUEST, SEARCH_SUCCESS, GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_SUCCESS, IGetUserPlotEventSummaryDataSuccessAction, GET_USER_PLOTS_FAIL } from "../actions/data.actions";
import { FLAG_PLOT_SUCCESS, CREATE_PLOT_REQUEST, CREATE_PLOT_SUCCESS, UPDATE_PLOT_REQUEST, UPDATE_PLOT_SUCCESS, UPLOAD_PLOT_PHOTOS_SUCCESS, UPLOAD_PLOT_PHOTOS_REQUEST, UPLOAD_PLOT_PHOTOS_FAILURE } from "../actions/dashboard.actions";
import { LOGOUT_SUCCESS } from "../actions/login.actions";
import { DELETE_EVENT_SUCCESS, MapAction } from "../actions/map.actions";
import { SAVE_EVENT_SUCCESS, SurveyAction, SAVE_EVENT_REQUEST } from "../actions/survey.actions";

export type DataState = {
    layers: DTOS.KMLLayer[];
    plotLoading: boolean;
    plotSaving: boolean;
    plotEventsLoading: boolean;
    plots: DTOS.Plot[];
    plotsLoading: boolean;
    plotPhotoUploading: boolean;
    saving: boolean;
    userPlots: DTOS.Plot[];
    userPlotsLoading: boolean;
    userPlotEventSummaryData: DTOS.PlatypusUserPlotsEventsSummary;
}

const initialState: DataState = {
    layers: [],
    plotLoading: false,
    plotSaving: false,
    plotEventsLoading: false,
    plots: undefined,
    plotsLoading: false,
    plotPhotoUploading: false,
    saving: false,
    userPlots: undefined,
    userPlotsLoading: false,
    userPlotEventSummaryData: undefined,
};

export default function data(state: DataState = initialState, action) {
    switch (action.type) {
        case DELETE_EVENT_SUCCESS:
            return removePlotEventFromPlots(state, action);

        case UPDATE_PLOT_REQUEST:
            return updatePlotSaving(state, true);
        case UPDATE_PLOT_SUCCESS:
            return updatePlotSaving(state, false);

        case UPLOAD_PLOT_PHOTOS_REQUEST:
            return updatePlotPhotoUploading(state, true);
        case UPLOAD_PLOT_PHOTOS_SUCCESS:
            return updatePlotPhotoUploading(state, false);
        case UPLOAD_PLOT_PHOTOS_FAILURE:
            return updatePlotPhotoUploading(state, false);


        case GET_USER_PLOTS_REQUEST:
            return updateUserPlotsLoading(state, true);
        case GET_USER_PLOTS_FAIL:
            return updateUserPlotsLoading(state, false);
        case GET_USER_PLOTS_SUCCESS:
            return updateUserPlots(state, action);

        case GET_PLOT_EVENTS_REQUEST:
            return updatePlotEventsLoading(state, true);
        case GET_PLOT_EVENTS_SUCCESS:
            return updatePlotEvents(state, action);

        case GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_SUCCESS:
            return updatePlatypusUserPlotEventSummaryData(state, action);

        case GET_PLOTS_REQUEST:
            return updatePlotsLoading(state, true);
        case GET_PLOTS_SUCCESS:
            return updatePlots(state, action);

        case GET_SINGLE_PLOT_REQUEST:
            return updateSinglePlotLoading(state, true);
        case GET_SINGLE_PLOT_SUCCESS:
            return updateSinglePlot(state, action);

        case GET_SUMMARY_DATA_SUCCESS:
            return updateSummaryData(state, action);

        case SEARCH_REQUEST:
            return clearErrors(state);
        case SEARCH_SUCCESS:
            return updateResults(state, action);

        case CREATE_PLOT_SUCCESS:
            return saving(state, false);
        case SAVE_EVENT_SUCCESS:
            return saving(savePlotEvent(state, action), false);
        case FLAG_PLOT_SUCCESS:
            return flagPlotSuccess(state, action);
        case DELETE_EVENT_SUCCESS:
            return deletePlotEvent(state, action);
        case CREATE_PLOT_REQUEST:
            return saving(state, true);
        case SAVE_EVENT_REQUEST:
            return clearData(state);
        case LOGOUT_SUCCESS:
            return clearData(state);
    }
    return state;
}

function clearData(state: DataState) {
    var newState = update(state, {
        error: { $set: undefined },
        plotEventsLoading: { $set: false },
        plots: { $set: undefined },
        plotsLoading: { $set: false },
        userPlots: { $set: undefined },
        userPlotsLoading: { $set: false },
        saving: { $set: false },
        summaryDataByClass: { $set: [] },
        plot: { $set: undefined },
        layers: { $set: [] },
    });

    return loadingData(newState, true);
}

function removePlotEventFromPlots(state: DataState, action): DataState {

    var newState: DataState = state;

    if (action.plotEventId) {

        const plotIndex = state.plots.findIndex(p => p.plotEvents.find(pe => pe.id === action.plotEventId) !== undefined);

        const plotEventIndex = state.plots[plotIndex].plotEvents.findIndex(pe => pe.id === action.plotEventId);

        newState = update(state, {
            plots: {
                [plotIndex]: {
                    plotEvents: {
                        $splice: [[plotEventIndex, 1]]
                    }
                }
            }
        })

    }

    return newState;
}

function updateSinglePlot(state: DataState, action: IGetSinglePlotSuccessAction): DataState {

    var newState: DataState = state;

    if (action.plot) {
        if (state.plots) {
            const index = state.plots.findIndex(p => p.id === action.plot.id)

            if (index === -1) {
                newState = update(state, {
                    plots: {
                        $push: [action.plot]
                    }
                })
            } else {
                newState = update(state, {
                    plots: {
                        [index]: {
                            $set: action.plot
                        }
                    }
                });
            }
        } else {
            newState = update(state, {
                plots: {
                    $set: [action.plot]
                }
            })
        }
    }

    return updateSinglePlotLoading(newState, false);
}

function updateSinglePlotLoading(state: DataState, isLoading: boolean) {
    const newState: DataState = update(state, {
        plotLoading: { $set: isLoading }
    })

    return newState;
}

function updateUserPlots(state: DataState, action: IGetUserPlotsSuccessAction): DataState {
    const newState: DataState = update(state, {
        userPlots: {
            $set: action.plots
        }
    })

    return updateUserPlotsLoading(newState, false);
}

function updateUserPlotsLoading(state: DataState, isLoading: boolean) {
    const newState: DataState = update(state, {
        userPlotsLoading: { $set: isLoading }
    })

    return newState;
}

function updatePlotEvents(state: DataState, action: IGetPlotEventsSuccessAction): DataState {
    const index = state.plots.findIndex(p => p.id === action.plotId)

    var newState: DataState = state;

    if (index !== -1) {
        newState = update(state, {
            plots: {
                [index]: {
                    plotEvents: {
                        $set: action.plotEvents
                    }
                }
            }
        });
    }

    return updatePlotEventsLoading(newState, false);
}

function updatePlotEventsLoading(state: DataState, isLoading: boolean) {
    const newState: DataState = update(state, {
        plotEventsLoading: { $set: isLoading }
    })

    return newState;
}


function updatePlatypusUserPlotEventSummaryData(state: DataState, action: IGetUserPlotEventSummaryDataSuccessAction): DataState {
    const newState: DataState = update(state, {
        userPlotEventSummaryData: {
            $set: action.userPlotEventSummaryData
        }
    });

    return newState;
}

function updatePlots(state: DataState, action: IGetPlotsSuccessAction): DataState {
    const newState: DataState = update(state, {
        plots: {
            $set: action.plots
        }
    })

    return updatePlotsLoading(newState, false);
}

function updatePlotsLoading(state: DataState, isLoading: boolean) {
    const newState: DataState = update(state, {
        plotsLoading: { $set: isLoading }
    })

    return newState;
}

function updateSummaryData(state: DataState, action: IGetSummaryDataSuccessAction): DataState {
    const newState: DataState = update(state, {
        summaryDataByClass: {
            $set: action.data
        }
    })
    return newState;
}

function updateResults(state: DataState, action: ISearchSuccessAction) {

    action.plots.sort(function (a, b) {
        if (!a.newestPlotEventDate && b.newestPlotEventDate) {
            return 1;
        }

        if (!b.newestPlotEventDate && a.newestPlotEventDate) {
            return -1;
        }

        else if (moment(a.newestPlotEventDate).isAfter(b.newestPlotEventDate)) {
            return -1;
        } else if (moment(b.newestPlotEventDate).isAfter(a.newestPlotEventDate)) {
            return 1;
        } else {
            return 0;
        }
    });

    const newState = update(state, {
        error: { $set: undefined },
        plots: { $set: action.plots },
        layers: { $set: action.layers }
    });

    return loadingData(newState, false);
}

function clearErrors(state: DataState) {
    var newState = update(state, {
        error: { $set: undefined }
    });

    return loadingData(newState, true);
}


function loadingData(state: DataState, isLoading: boolean) {
    let newState = update(state, {
        plotsLoading: { $set: isLoading }
    });
    return newState;
}

function flagPlotSuccess(state: DataState, action) {

    const newState: DataState = update(state, {
        userPlots: {
            $set: action.plots
        }
    })

    return newState;


    /*let newState: DataState = update(state, {
        plot: {
            registered: { $set: !state.plot.registered }
        }
    });

    let newState = state.plots.find(i => i.id === state.plot.id);
    let index = newState.plots.indexOf(existingPlot);

    if (index >= 0) {
        newState = update(newState, {
            plots: {
                [index]: {
                    registered: { $set: !state.plot.registered }
                }
            }
        });
    }
*/
}

function deletePlotEvent(state: DataState, action: MapAction) {
    /*let newState = state;

    if (action.plotEventId && action.success) {
        var plot = state.plots.find(d => d.plotEvents.filter(e => e.id == action.plotEventId).length > 0);
        let existingPlot = state.plots.find(i => i.id === plot.id);
        let index = state.plots.indexOf(existingPlot);
        if (index >= 0) {
            let plotEvent = plot.plotEvents.find(i => i.id === action.plotEventId);
            let eventIdx = plot.plotEvents.indexOf(plotEvent);
            if (eventIdx >= 0) {
                newState = update(newState, {
                    plots: {
                        [index]: {
                            plotEvents: { $splice: [[eventIdx, 1]] }
                        }
                    }
                });
            }
        }

        // check if the current save is the current viewing plot and update it
         (state.plot && state.plot.id === existingPlot.id && !existingPlot.obsolete) {
            existingPlot = newState.plots.find(i => i.id === plot.id);
            newState = update(newState, {
                plot: { $set: existingPlot }
            });
        }
}

    return newState;*/
}

function savePlotEvent(state: DataState, action: SurveyAction) {
    return state;
    /*let newState = state;
    var plotEvent = action.plotEvent;

    if (action.plotEvent.id && state.plots) {

        let existingPlot = state.plots.find(i => i.id === action.plotEvent.plotId);
        let index = state.plots.indexOf(existingPlot);

        if (index >= 0) {
            newState = update(newState, {
                plots: {
                    [index]: {
                        plotEvents: { $push: [plotEvent] }
                    }
                }
            });
        }

        //check if the current save is the current viewing plot and update it
        if (state.plot && state.plot.id === existingPlot.id && !existingPlot.obsolete) {
            newState = update(newState, {
                plot: { $set: existingPlot }
            });
        }
    }

    return newState;*/
}

/*function savePlot(state: DataState, action: DashboardAction) {
    let newState = state;
    var plot = action.plot;
    if (plot && plot.id) {
        let existingPlot = state.plots.find(i => i.id === plot.id);
        let index = state.plots.indexOf(existingPlot);
        if (index >= 0) {
            if (plot.obsolete) {
                newState = update(newState, {
                    plots: { $splice: [[index, 1]] }
                });
            } else {
                plot.plotEvents = existingPlot.plotEvents;
                newState = update(newState, {
                    plots: {
                        [index]: { $set: plot }
                    }
                });
            }
        } else {
            newState = update(newState, {
                plots: { $push: [plot] }
            });
        }
    }

    //check if the current save is the current viewing plot and update it
    if (state.plot && state.plot.id === plot.id && !plot.obsolete) {
        newState = update(newState, {
            plot: { $set: action.plot }
        });
    } else if (state.plot && state.plot.id === plot.id && plot.obsolete) {
        newState = update(newState, {
            plot: { $set: undefined }
        });
    }
    return newState;
}*/

function saving(state: DataState, saving: boolean) {
    let newState = update(state, {
        saving: { $set: saving }
    });
    return newState;
}

function updatePlotSaving(state: DataState, saving) {
    return update(state, {
        plotSaving: { $set: saving }
    })
}

function updatePlotPhotoUploading(state: DataState, saving) {
    return update(state, {
        plotPhotoUploading: { $set: saving }
    })
}